import { UserEntity } from 'app/interfaces/entity';
import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { UserAvatar } from 'shared/components/UserAvatar';
import { useSelector } from 'react-redux';
import { sessionSelector } from 'app/store/session/selectors';
import isEmpty from 'lodash/isEmpty';
import { useStyles } from './ProfileTile.styles';

export const ProfileTile: FC = () => {
  const { classes } = useStyles();
  const user = useSelector(sessionSelector.activeUser);

  if (!user || isEmpty(user)) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <UserAvatar user={user as UserEntity} />
      <Typography className={classes.username}>{user?.userName}</Typography>
    </Box>
  );
};
